export default __webpack_public_path__ + "static/media/mount_tool.6c5a4874.svg";